<template>
    <v-row>
        <v-col cols="12" sm="12" md="12" class="pb-0">
            <table-cadu
                class="dominio"
                v-model="selected"
                :showCheck="false"
                custom
                :loading="loading"
                :showSelect="false"
                :showFiltro="false"
                :rows="rows"
                :rowsHeader="rowsHeader"
                :disabledButtons="[]"
                :ordemProp="ordemProp"
                nameTab="tabelaDominio"
                @ordena="obj => changeOrdem(obj)"
            />
        </v-col>
        <error-modal
          v-model="error"
          :errObj="errObj"
        />
    </v-row>
</template>

<script>
import TabelaDominios from '@/services/Dominios/TabelaDominios'

export default {
  props: {
    args: {
      type: String,
      default: ''
    },
    ordemProp: {
      type: String,
      default: 'asc'
    }
  },
  data () {
    return {
      selected: [],
      rows: [],
      rowsHeader: [
        { text: 'Tabela' },
        { text: 'Descrição do campo', icon: 'repeat' },
        { text: 'Ordem', icon: 'repeat' },
        { text: 'Status', icon: 'repeat' }
      ],
      ordemData: this.ordemProp,
      loading: false,
      tokenBearer: localStorage.getItem('tokenBearer'),
      error: false,
      errObj: {}
    }
  },
  methods: {
    async loadingTabelaDominio (args) {
      this.loading = true
      await this.getTabelaDominio(args)
      this.loading = false
    },
    async getTabelaDominio (args) {
      const tabelaDominios = new TabelaDominios(this.tokenBearer, this.$appConfig.config.API)

      try {
        let responseGet = await tabelaDominios.getTabelaDominios(args)
        this.rows = responseGet.data
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        console.error(err)
      }
    },
    changeOrdem (obj) {
      const tipoOrdenacao = () => {
        switch (obj.index) {
          case 1:
            return 'nome'
          case 2:
            return 'ordem'
          case 3:
            return 'ativo'
        }
      }
      this.ordemData = obj.ordem
      const object = { ordem: this.ordemData, ordenacao: tipoOrdenacao() }

      this.$emit('ordenacao', object)
    }
  },
  watch: {
    ordemProp () {
      this.ordemData = this.ordemProp
    }
  }
}
</script>

<style lang="sass">
.dominio > .table-cadu
    border: none
    border-radius: 0px
    width: 100% !important
    padding-bottom: 4px
    padding: 0px !important

.dominio > .table-cadu > .table
  max-height: 240px
  overflow: auto
  table
    width: 100%
    tbody
        tr
            td
                &:last-child
                    text-align: end !important
</style>
